'use client'
import { TitleDivider } from 'components/TitleDivider'
import { useMemoizedContentGetter } from 'utils/contentful'
import styles from './AboutEmployeeResourceGroups.module.scss'
import { AchieveTheme, Grid } from '@achieve/ascend'
import Section from 'components/Section'
import { CardAboutERP } from 'components/Cards'

function AboutEmployeeResourceGroups({ content }) {
  const { title, subtitle, grid, theme } = useMemoizedContentGetter(content, [
    'title',
    'subtitle',
    'grid',
    'theme',
  ])

  const [imageWidth, imageHeight] = ['310', '220']

  const backgroundColor = theme?.theme[0]
    ? AchieveTheme?.ascend?.colors?.blue?.[50]
    : AchieveTheme?.ascend?.colors?.neutral?.[0]

  return (
    <Section
      backgroundColor={backgroundColor}
      data-testid="about-erp-section"
      className={styles['section']}
    >
      <Grid
        container
        data-testid="value-prop-grid-container"
        className={styles['outer-grid-container']}
      >
        <Grid item className={styles['grid-wrapper']}>
          <TitleDivider
            data-testid="value-prop-title-divider"
            title={title}
            subtitle={subtitle}
            classNameTitleText={'displaySm lg:displayLg'}
            classNameSubtitleText={'text-center bodySm lg:displaySm font-light! mt-4'}
          />
        </Grid>
        <Grid
          data-testid="about-erp-grid-card-container"
          container
          className={styles['card-grid']}
          spacing={0}
        >
          {grid?.gridItemsCollection?.items?.map((item, idx) => (
            <Grid
              size={{ xs: 12, lg: 6, xl: 4 }}
              className={styles['grid-item-container']}
              data-testid={`about-erp-grid-card-${idx}`}
              key={idx}
            >
              <CardAboutERP content={item} imageWidth={imageWidth} imageHeight={imageHeight} />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Section>
  )
}
export { AboutEmployeeResourceGroups }
export default AboutEmployeeResourceGroups
